import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function grid(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      column = _ref2.column,
      columnStart = _ref2.columnStart,
      columnEnd = _ref2.columnEnd,
      row = _ref2.row,
      rowStart = _ref2.rowStart,
      rowEnd = _ref2.rowEnd,
      styles = _objectWithoutPropertiesLoose(_ref2, ["column", "columnStart", "columnEnd", "row", "rowStart", "rowEnd"]);

  if (column !== undefined && styles.gridColumn === undefined) {
    styles.gridColumn = column;
  }

  if (columnStart !== undefined && styles.gridColumnStart === undefined) {
    styles.gridColumnStart = columnStart;
  }

  if (columnEnd !== undefined && styles.gridColumnEnd === undefined) {
    styles.gridColumnEnd = columnEnd;
  }

  if (row !== undefined && styles.gridRow === undefined) {
    styles.gridRow = row;
  }

  if (rowStart !== undefined && styles.gridRowStart === undefined) {
    styles.gridRowStart = rowStart;
  }

  if (rowEnd !== undefined && styles.gridRowEnd === undefined) {
    styles.gridRowEnd = rowEnd;
  }

  return styles;
}

export default grid;